import React from 'react';
import Sidebar from './Sidebar';
import { Toaster } from './ui/sonner';

export default function Layout({ children, title, subtitle, actions }) {
  return (
    <div className="min-h-screen flex bg-zinc-50">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <header className="bg-white border-b border-zinc-200 px-8 py-6 sticky top-0 z-10">
          <div className="flex items-start justify-between gap-4">
            <div>
              {subtitle && (
                <div className="text-[10px] text-zinc-500 uppercase tracking-[0.2em] mb-1" data-testid="page-subtitle">
                  {subtitle}
                </div>
              )}
              <h1 className="font-display font-bold text-3xl tracking-tighter text-zinc-950" data-testid="page-title">
                {title}
              </h1>
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        </header>
        <div className="p-8">{children}</div>
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
